module.exports = __webpack_public_path__ + "img/instantExchange1.151509e1.png";